import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Picker,Popup,Swipe,SwipeItem } from 'vant'

import './assets/css/h5reset.css'
import './assets/js/rem.js'
import './assets/css/iconfont.css'

const app = createApp(App)
localStorage.newsid = '36001800018'


// app.config.globalProperties.axiosurl = '/hallapi'
// app.config.globalProperties.axiosurlTow='/wwwapi'
// app.config.globalProperties.axiosurl = 'http://tcs.fengkuangtiyu.cn/'
//app.config.globalProperties.axiosurl = 'https://t.zgzcw.com/'
app.config.globalProperties.axiosurlTow='https://www.fkhongdan.com'
app.config.globalProperties.axiosurl = ''
app.use(store).use(router).use(Picker).use(Popup).use(Swipe).use(SwipeItem).mount('#app')











